module.exports = __webpack_public_path__ + "img/yajirushi_formbutton.4974ebcd.png";